export default __webpack_public_path__ + "static/media/i_usdt.36d8a933.svg";